import {AuthPiece} from "aws-amplify-react";
import {Auth} from "aws-amplify";
import React from "react";

import SimpleReactValidator from 'simple-react-validator';
import axiosBase from "axios";
import APP_ENV from "../Environment";
import {ConfirmChangeEmailComponents} from "../Components/ConfirmChangeEmailComponents";
import {err_logger} from "../Logics/logger";
import {resend_verify_code_for_user_attributes} from "../Logics/cognito_process";
import {STYLE_DISABLE_LINK, STYLE_LINK} from "../Styles/style";

export default class ConfirmChangeEmail extends AuthPiece  {
    constructor(props) {
        super(props);
        this.state = {
            code: "",
            isSendChangeEmail : false,
            isSendCodeBtnDisable: false,
            resendCodeStyle: STYLE_LINK,
        };
        this._validAuthStates = ['ConfirmChangeEmail'];
        this.handleInputChangeCustom = this.handleInputChangeCustom.bind(this);
        this.veryfyAttribute = this.veryfyAttribute.bind(this);
        this.resend = this.resend.bind(this);
        this.validator = new SimpleReactValidator(
            {
                className: 'text-danger',
                messages: {
                    required: "入力必須項目です"
                }
            }
        );

    }
    componentDidUpdate(prevProps) {
        if ((prevProps.authState === 'signIn' || prevProps.authState === 'ChangeEmail') && !this.state.isSendChangeEmail && this.props.authData && this.props.authData.isSendChangeEmail) {
            this.error("新しいメールアドレスに認証コードを送信しました。ご入力をお願いします。")
            this.setState({
                isSendChangeEmail: true
            })
        }

    }

    async resend() {
        this.setState({
            isSendCodeBtnDisable: true,
            resendCodeStyle : STYLE_DISABLE_LINK
        });
        const user = this.props.authData.user;
        try {
            await resend_verify_code_for_user_attributes(user);
            this.error("コードを再送信しました")
        } catch (err) {
            this.error("コードの再送信に失敗しました")
            err_logger(this.props.authData.email, err, "failure resend code for update email",{ sub: user.attributes.sub });
        } finally {
            this.setState({
                isSendCodeBtnDisable: false,
                isSendChangeEmail: false,
                resendCodeStyle: STYLE_LINK
            });

        }
     }

    validate() {
        let err  = false;
        if (!this.validator.allValid()) {
            this.validator.showMessages();
            err  = true;
            this.forceUpdate();
        }
        return err;
    }

    async veryfyAttribute() {
        const err = this.validate();
        if (err) {
            return;
        }
        this.setState({
            isSendCodeBtnDisable: true,
            resendCodeStyle : STYLE_DISABLE_LINK
        });

        try {
            await Auth.verifyCurrentUserAttributeSubmit("email", this.state.code);
            const user = this.props.authData.user;
            const axios = axiosBase.create({
                baseURL: APP_ENV.BFF,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${user.signInUserSession.idToken.jwtToken}`
                },
                responseType: 'json'
            });
            axios.put(APP_ENV.BFF + "/user", {
                customer_id: user.signInUserSession.idToken.payload["custom:ecc_customer_id"],
                email: this.props.authData.email,
                sub: user.attributes.sub})
                .then(() => {
                    this.setState({
                        isSendCodeBtnDisable: false,
                        isSendChangeEmail: false,
                        resendCodeStyle: STYLE_LINK,
                    });
                    window.history.replaceState('','','/');
                    // 更新成功画面を表示
                    this.changeState('CompChangeEmail', user);
                })
                .catch((e) => {
                    this.setState({
                        isSendCodeBtnDisable: false,
                        isSendChangeEmail: false,
                        resendCodeStyle: STYLE_LINK,
                    });
                    this.error("メールアドレスの更新に失敗しました");
                    err_logger(this.props.authData.email, e, "failure update email",{sub: user.attributes.sub });
                });

        } catch (err) {
            this.setState({
                isSendCodeBtnDisable: false,
                isSendChangeEmail: false,
                resendCodeStyle: STYLE_LINK,
            });
            err_logger(this.props.authData.email, err, "verifyCurrentUserAttributeSubmit of email",{attribute_name: "email", code : this.state.code});
            this.error("メールアドレスの更新に失敗しました");
        } finally {
        }
    }
    handleInputChangeCustom(e) {
        this.setState({
            [e.target.name] : e.target.value
        });
    }

    showComponent(theme) {
        return (
            <ConfirmChangeEmailComponents theme={theme} handleInputChangeCustom={this.handleInputChangeCustom}
                                          code_err_msg={this.validator.message("code", this.state.code, 'required')}
                                          veryfyAttribute={this.veryfyAttribute} resend={this.resend} isSendCodeBtnDisable={this.state.isSendCodeBtnDisable}
                                          resendCodeStyle={this.state.resendCodeStyle}/>
        )
    }
}